"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.flattenChildren = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _react = _interopRequireDefault(require("react"));

var flattenChildren = function flattenChildren(children) {
  var _context;

  return (0, _reduce.default)(_context = _react.default.Children.toArray(children)).call(_context, function (result, child) {
    if (child.type === _react.default.Fragment) {
      var _context2;

      return (0, _concat.default)(_context2 = []).call(_context2, (0, _toConsumableArray2.default)(result), (0, _toConsumableArray2.default)(flattenChildren(child.props.children)));
    } else {
      var _context3;

      return (0, _concat.default)(_context3 = []).call(_context3, (0, _toConsumableArray2.default)(result), [child]);
    }
  }, []);
};

exports.flattenChildren = flattenChildren;